const questions = [
    {
        id: 0,
        question:
            "¿Qué requerimientos técnicos necesito para participar en el curso?",
        answer: (
            <div>
                Computadora gama media Core i5 de 8GB de RAM y tarjeta de vídeo
                (como mínimo), Acceso a internet estable.
            </div>
        ),
    },
    {
        id: 1,
        question: "¿Qué debo hacer después de pagar?",
        answer: (
            <div>
                Una vez el pago sea exitoso debes verificar si el curso está en
                tu cuenta. Si después de pagar no te aparece el curso, envía tu
                comprobante de pago a coordinacionacademica@libel.academy
                solicitando la activación del contenido.
            </div>
        ),
    },
    {
        id: 2,
        question: "¿El curso incluye certificado?",
        answer: (
            <div>
                Este curso no incluye certificado, pero tenemos una gran
                cantidad de cursos en Blender que sí incluyen certificados, no
                olvides revisarlos.
            </div>
        ),
    },
    {
        id: 3,
        question: "¿Cómo descargo los vídeos del curso?",
        answer: (
            <div>
                Los vídeos del curso se descargan desde tu cuenta. Una vez
                tengas el curso activo en tu cuenta, también aparecerá una guía
                para que puedas descargarlos.
            </div>
        ),
    },
    {
        id: 4,
        question: "¿Necesito conocimientos previos en Blender?",
        answer: (
            <div>
                No, te enseñaremos desde cero, paso a paso. Solo necesitas ganas
                de aprender y compromiso con las clases
            </div>
        ),
    },
];

export default questions;
